import { REFERO_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';

import type { ResourceItem } from '@helsenorge/framework-utils/resources';
import type { Resources } from '@helsenorge/refero';

type ReferoResources = ResourceItem & Resources;

export const useGetSchemaResources = (): Resources | undefined => {
  const resources = useResources<ReferoResources>(REFERO_RESOURCES);

  if (!resources) return;
  return resources;
};
